import React, {useContext} from 'react';
import * as PropTypes from 'prop-types';

import Link from '@components/link';

import {DataContext} from 'contexts';

import FirmIcon from '../FirmIcon';
import ReviewsCounter from '../ReviewsCounter';
import styles from './styles.modules.scss';

const FirmInfo = ({id, firm, icons}) => {
    const { openPassport } = useContext(DataContext);

    return (
        <div className={styles['info']}>
            <div className={styles['name']}>
                <Link
                    className={styles['firm-link']}
                    rel="noopener"
                    size="large"
                    target="_blank"
                    onClick={() => openPassport(id)}
                >
                    {`${firm.firmName}, ${firm.ownership}`}
                </Link>
                <span className={styles['firm-location']}>
                    {firm.cityName}
                </span>
            </div>
            <div className={styles['icons']}>
                <FirmIcon
                    icon={icons?.starsIcon}
                    id={id}
                />
                <FirmIcon
                    icon={icons?.trafficLightIcon}
                    id={id}
                />
                <FirmIcon
                    icon={icons?.reputationSignalIcon}
                    id={id}
                />
                <FirmIcon
                    icon={icons?.countryRatingInfo}
                    id={id}
                />
                <FirmIcon
                    icon={icons?.cityRatingInfo}
                    id={id}
                />
                <FirmIcon
                    icon={icons?.realTruckerIcon}
                    id={id}
                    imageClassName={styles['trucker-icon']}
                    size="medium"
                />
                <FirmIcon
                    icon={icons?.ordersParticipantIcon}
                    id={id}
                />
                <FirmIcon
                    icon={icons?.atiDocsIcon}
                    id={id}
                />
                <div className={styles['firm-additional']}>
                    <ReviewsCounter firm={firm}/>
                    <span className={styles['firm-type']}>
                        {firm.firmType?.toLowerCase() || ''}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default FirmInfo;

FirmInfo.propTypes = {
    firm: PropTypes.object,
    icons: PropTypes.object,
    id: PropTypes.string
};
